import capitalize from 'lodash/capitalize';
import lowerCase from 'lodash/lowerCase';

import {
  Box,
  Button,
  ChipFilter,
  Flex,
  IconCheck,
  IconColumns,
  Menu,
  MenuRoot,
  MenuRow,
} from '@spotify-internal/encore-web';
import { Popover } from '@spotify-internal/encore-web/next';
import { SearchField } from '@spotify/confidence-core-react';

import styles from './CollectionEntriesToolbar.module.css';

export type TypeOption = {
  id: string;
  label: string;
};

type CollectionEntriesToolbarProps = {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  typeFilter: string;
  availableTypes: TypeOption[];
  onTypeSelect: (typeId: string) => void;
  allColumnIds: string[];
  hiddenColumns: Set<string>;
  onToggleColumn: (columnId: string) => void;
};

const ALL_TYPES = 'all';

export const CollectionEntriesToolbar = ({
  searchQuery,
  onSearchChange,
  typeFilter,
  availableTypes,
  onTypeSelect,
  allColumnIds,
  hiddenColumns,
  onToggleColumn,
}: CollectionEntriesToolbarProps) => (
  <Box
    className={styles.toolbar}
    paddingBlockStart="base"
    paddingBlockEnd="base"
  >
    <Flex gap="tighter-2">
      <Flex className={styles.toolbarPrimary} gap="tighter">
        <SearchField
          className={styles.searchField}
          placeholder="Search entries"
          aria-label="Search entries"
          value={searchQuery}
          onChange={e => onSearchChange(e.currentTarget.value)}
         data-track-source-anchor="a659f84fdc"/>
        {availableTypes.length > 1 && (
          <Flex gap="tighter-2">
            <ChipFilter
              isSelected={typeFilter === ALL_TYPES}
              onClick={() => onTypeSelect(ALL_TYPES)}
             data-track-source-anchor="8347405fdf">
              All
            </ChipFilter>
            {availableTypes.map(type => (
              <ChipFilter
                key={type.id}
                isSelected={typeFilter === type.id}
                onClick={() => onTypeSelect(type.id)}
               data-track-source-anchor="bd770af820;collection-entries-toolbar-chip-filter">
                {type.label}
              </ChipFilter>
            ))}
          </Flex>
        )}
      </Flex>
      <MenuRoot>
        <Button variant="tertiary" size="small" data-track-source-anchor="c319aa656e">
          <IconColumns size="small" />
          Columns
        </Button>
        <Popover hasNoArrow>
          <Menu aria-label="Toggle columns">
            {allColumnIds.map(id => (
              <MenuRow
                key={id}
                id={id}
                textValue={capitalize(lowerCase(id))}
                onAction={() => onToggleColumn(id)}
               data-track-source-anchor="5f6da66d5c;collection-entries-toolbar-menu-row;low">
                <Flex gap="tighter" alignItems="center">
                  <span className={styles.checkIcon}>
                    {!hiddenColumns.has(id) && <IconCheck size="small" />}
                  </span>
                  {capitalize(lowerCase(id))}
                </Flex>
              </MenuRow>
            ))}
          </Menu>
        </Popover>
      </MenuRoot>
    </Flex>
  </Box>
);
